import { useAuth } from '~/store/auth'

export default defineNuxtRouteMiddleware(() => {
  const userStore = useAuth()
  if (!userStore.isAdmin) {
    return navigateTo('/')
  }
})
